import { render } from "./StrategyCard.vue?vue&type=template&id=19bb25bf&scoped=true&ts=true"
import script from "./StrategyCard.vue?vue&type=script&lang=ts"
export * from "./StrategyCard.vue?vue&type=script&lang=ts"

import "./StrategyCard.vue?vue&type=style&index=0&id=19bb25bf&scoped=true&lang=css"
import "./StrategyCard.vue?vue&type=style&index=1&id=19bb25bf&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bb25bf"]])

export default __exports__